const searchBoxToggles = document.querySelectorAll(
    '[data-toggle="search-box"]',
);

searchBoxToggles.forEach((toggle) => {
    toggle.addEventListener("click", toggleSearchBox);
});

function toggleSearchBox(e) {
    e && e.preventDefault();

    const searchBoxEl = document.getElementById("search-box");
    if (searchBoxEl) {
        searchBoxEl.classList.toggle("is-open");
        searchBoxToggles.forEach((toggle) => {
            toggle.classList.toggle("is-open");
        });
    }
}
